import type { WebsitePerformanceReportId } from '@brightlocal/shared';

import type { WebsitePerformanceGetReportsParams } from './schema';
import { WebsitePerformanceReportsResponseSchema, WebsitePerformanceRunSchema } from './schema';
import { HTTP_METHOD } from '../../../consts';
import type { ApiCallOptions, Transport } from '../../../types';

export const createWebsitePerformanceApi = (transport: Transport) => ({
  getReports: (params?: WebsitePerformanceGetReportsParams, options?: ApiCallOptions) =>
    transport('/manage/v1/website-performance/reports', {
      method: HTTP_METHOD.GET,
      deserializer: WebsitePerformanceReportsResponseSchema,
      signal: options?.signal,
      // transport skips undefined/null keys, so unset params are omitted from the URL automatically
      queryParams: params
        ? { location_id: params.locationId, page: params.page, num_per_page: params.numPerPage }
        : undefined
    }),
  getLatestRun: (reportId: WebsitePerformanceReportId, options?: ApiCallOptions) =>
    transport(`/manage/v1/website-performance/reports/${reportId}/runs/latest`, {
      method: HTTP_METHOD.GET,
      deserializer: WebsitePerformanceRunSchema,
      signal: options?.signal
    })
});

export type WebsitePerformanceApi = ReturnType<typeof createWebsitePerformanceApi>;
